<footer class="footer" data-test-id="footer">
	<div
		[ngClass]="
			isMinimal()
				? 'flex-col items-center gap-6 py-4 md:flex-row md:justify-between'
				: 'flex-col'
		"
		class="mx-auto flex w-full max-w-screen-2xl px-3 md:relative md:px-8 2xl:px-10"
	>
		@if (!isMinimal()) {
			<div class="self-center md:self-start">
				<button
					(click)="scrollToTop()"
					class="footer-button visited:text-white hover:cursor-pointer"
					role="button"
					type="button"
				>
					{{ 'global.to-top' | translate }}
				</button>
			</div>
		}
		@if (logoLink()) {
			<div
				[ngClass]="isMinimal() ? 'flex-row' : 'flex-col py-6 md:pt-0'"
				class="flex"
			>
				@if (transformedTitle()) {
					<vp-link
						[className]="
							'flex items-center font-logo uppercase' +
							(isMinimal() ? ' flex-row' : ' flex-col')
						"
						[link]="logoLink()!"
						class="mx-auto"
						data-test-id="footer-logo"
						type="link-unstyled"
					>
						<svg-icon
							[src]="
								isMinimal()
									? 'assets/logos/' +
										transformedTitle() +
										'.svg'
									: 'assets/logos/centered/' +
										transformedTitle() +
										'-centered.svg'
							"
							[svgStyle]="{
								'height.px': isMinimal() ? 40 : 114,
								width: 'auto',
								maxWidth: '100%',
							}"
						/>
					</vp-link>
				}
			</div>
		}
		@if (!isMinimal()) {
			<hr class="my-2 divider footer-divider opacity-25" />
			<div class="my-3 flex flex-wrap justify-center gap-y-3">
				@for (usp of usps(); track $index) {
					<div
						class="flex w-1/2 flex-col items-center md:w-44"
						data-test-class="usp-item"
					>
						<vp-link
							[link]="{ url: usp.url, title: usp.text }"
							className="flex flex-col items-center text-center text-white! no-underline visited:text-white hover:text-white md:w-44"
						>
							<div
								class="mb-1 size-10 rounded-full footer-bg-brand p-2"
							>
								<svg-icon
									[src]="usp.icon"
									class="block size-6 text-white"
								/>
							</div>
							{{
								usp.text || 'global.best-price-guarantee'
									| translate
							}}
						</vp-link>
					</div>
				}
			</div>
			<hr class="my-2 mb-10 divider footer-divider opacity-25" />
			<div
				class="mb-10 flex flex-col justify-center gap-x-6 gap-y-10 md:flex-row lg:mx-1/6"
			>
				@for (menuItems of menu().items; track $index) {
					<div
						[ngClass]="{
							'md:w-1/4 lg:w-1/6': menu().items.length !== 1,
							'flex flex-col justify-center':
								menu().items.length === 1,
						}"
						class="grow basis-0"
					>
						<span
							class="mb-4 block text-center text-2xl font-semibold md:text-left"
						>
							{{ menuItems.title }}
						</span>
						<ul class="flex flex-col gap-y-4">
							@for (menuItem of menuItems.items; track $index) {
								@if (menuItem.title) {
									<li class="text-center md:text-left">
										<vp-link
											[link]="menuItem"
											className="text-lg font-normal text-white! no-underline"
										>
											{{ menuItem.title }}
										</vp-link>
									</li>
								}
							}
						</ul>
					</div>
				}

				@if (showContactSection()) {
					<div
						class="flex grow-[1] basis-0 flex-col"
						data-test-id="contact"
					>
						<span
							class="mb-4 text-center text-2xl font-semibold md:text-left"
						>
							{{ 'components.footer.contact-title' | translate }}
						</span>
						@if (information()?.contact) {
							<div class="flex flex-col gap-y-6">
								@if (information()!.contact.phone) {
									<div
										class="flex flex-col items-center gap-y-1 md:items-start"
									>
										<span class="block text-light-primary">
											{{
												'components.footer.phone-information'
													| translate
											}}
										</span>
										<div class="flex footer-text-brand">
											<a
												[href]="
													'tel:' +
													information()!.contact.phone
												"
												class="flex items-center gap-2 text-lg no-underline"
												data-test-id="phone-number"
											>
												<svg-icon
													class="block size-4"
													src="assets/icons/icon-phone.svg"
												/>
												{{
													information()!.contact.phone
												}}
											</a>
										</div>
									</div>
								}
								@if (information()!.contact.email) {
									<div
										class="flex flex-col items-center gap-y-1 md:items-start"
									>
										<span class="block text-light-primary">
											{{
												'components.footer.email-information'
													| translate
											}}
										</span>
										<div class="flex footer-text-brand">
											<a
												[href]="
													'mailto:' +
													information()!.contact.email
												"
												class="flex items-center gap-2 text-lg no-underline"
												data-test-id="email-address"
											>
												<svg-icon
													class="block size-4"
													src="assets/icons/icon-envelope.svg"
												/>
												{{
													information()!.contact.email
												}}
											</a>
										</div>
									</div>
								}
								@if (socials()?.whatsapp) {
									<div
										class="flex flex-col items-center gap-y-1 md:items-start"
									>
										<span class="block text-light-primary">
											{{
												'components.footer.whatsapp-information'
													| translate
											}}
										</span>
										<div class="flex footer-text-brand">
											<a
												[href]="
													socials().whatsapp
														| whatsapp
												"
												class="flex items-center gap-2 text-lg no-underline"
												data-test-id="whatsapp-number"
											>
												<svg-icon
													class="block size-4"
													src="assets/icons/icon-whatsapp.svg"
												/>
												{{ socials().whatsapp }}
											</a>
										</div>
									</div>
								}
							</div>
						}
						@if (information()?.address) {
							<div
								class="mt-10 flex flex-col items-center md:items-start"
							>
								@if (information()!.name) {
									<span
										class="mb-1 text-xl font-semibold"
										data-test-id="hotel-name"
									>
										{{ information()!.name }}
									</span>
								}
								<span
									class="text-lg text-light-secondary"
									data-test-id="address"
								>
									{{ information()!.address.street }}
									{{ information()!.address.streetNumber }}
									{{
										information()!.address
											.streetNumberAddition
									}}
								</span>
								<span
									class="text-lg text-light-secondary"
									data-test-id="postal-code"
								>
									{{ information()!.address.postalCode }}
								</span>
								<span
									class="text-lg text-light-secondary"
									data-test-id="city"
								>
									{{ information()!.address.city }}
								</span>
								@if (planRouteUrl()) {
									<div class="mt-3 flex footer-text-brand">
										<a
											[href]="planRouteUrl()"
											class="flex items-center gap-2 text-lg no-underline"
											data-test-id="route"
											rel="referrer noopener"
											target="_blank"
										>
											<svg-icon
												class="block size-5"
												src="assets/icons/icon-location-marker.svg"
											/>
											{{
												'components.footer.plan-route'
													| translate
											}}
										</a>
									</div>
								}
							</div>
						}
						@if (
							company()?.name ||
							company()?.registrationNumber ||
							company()?.vatNumber
						) {
							<div
								class="mt-10 flex flex-col items-center md:items-start"
							>
								<span
									class="mb-1 text-xl font-semibold"
									data-test-id="company-title"
								>
									{{
										'components.footer.company-title'
											| translate
									}}
								</span>

								@if (company()?.name) {
									<span
										class="text-lg text-light-secondary"
										data-test-id="company-name"
									>
										{{
											'components.footer.company-name'
												| translate
										}}:
										{{ company()!.name }}
									</span>
								}
								@if (company()?.registrationNumber) {
									<span
										class="text-lg text-light-secondary"
										data-test-id="registration-number"
									>
										{{
											`components.footer.registration-number.${information()?.address.countryCode?.toLowerCase()}`
												| translate
										}}:
										{{ company()!.registrationNumber }}
									</span>
								}
								@if (company()?.vatNumber) {
									<span
										class="text-lg text-light-secondary"
										data-test-id="vat-number"
									>
										{{
											'components.footer.vat-number'
												| translate
										}}:
										{{ company()!.vatNumber }}
									</span>
								}
							</div>
						}
					</div>
				}
			</div>
		}
		<div class="flex flex-row">
			<div class="w-full">
				<div
					[ngClass]="{ 'mb-10 pt-5': !isMinimal() }"
					class="flex w-full flex-wrap justify-center gap-x-4 gap-y-3 md:gap-x-10"
				>
					@if (socials()?.facebook) {
						<ng-container
							[ngTemplateOutlet]="social"
							[ngTemplateOutletContext]="{
								link: socials()!.facebook,
								social: 'Facebook',
								icon: 'facebook',
							}"
						/>
					}
					@if (socials()?.instagram) {
						<ng-container
							[ngTemplateOutlet]="social"
							[ngTemplateOutletContext]="{
								link: socials()!.instagram,
								social: 'Instagram',
								icon: 'instagram',
							}"
						/>
					}
					@if (socials()?.tiktok) {
						<ng-container
							[ngTemplateOutlet]="social"
							[ngTemplateOutletContext]="{
								link: socials()!.tiktok,
								social: 'Tiktok',
								icon: 'tiktok',
							}"
						/>
					}
					@if (socials()?.linkedin) {
						<ng-container
							[ngTemplateOutlet]="social"
							[ngTemplateOutletContext]="{
								link: socials()!.linkedin,
								social: 'LinkedIn',
								icon: 'linkedin',
							}"
						/>
					}
					@if (socials()?.youtube) {
						<ng-container
							[ngTemplateOutlet]="social"
							[ngTemplateOutletContext]="{
								link: socials()!.youtube,
								social: 'Youtube',
								icon: 'youtube',
							}"
						/>
					}
					@if (socials()?.pinterest) {
						<ng-container
							[ngTemplateOutlet]="social"
							[ngTemplateOutletContext]="{
								link: socials()!.pinterest,
								social: 'Pinterest',
								icon: 'pinterest',
							}"
						/>
					}
				</div>
			</div>
		</div>
	</div>
	<div class="footnote">
		<div
			class="mx-auto flex w-full max-w-screen-2xl flex-col px-3 md:relative md:px-8 md:py-4 2xl:px-10"
		>
			<ul
				[class]="
					cn(
						'mb-6 flex flex-wrap justify-center gap-4 text-light-primary md:my-0',
						isMinimal()
							? 'md:justify-end md:self-end'
							: 'md:self-center'
					)
				"
			>
				@for (item of bottomItems(); track $index) {
					<li class="text-sm" data-test-class="bottom-item">
						<vp-link
							[link]="item"
							className="text-light-primary! no-underline visited:text-light-primary"
						>
							{{ item.text }}
						</vp-link>
					</li>
				}
			</ul>
		</div>
	</div>
</footer>

<ng-template #social let-icon="icon" let-link="link" let-social="social">
	<a
		[attr.data-test-id]="'social-link-' + social"
		[href]="link"
		class="flex items-center gap-x-2 text-lg text-light-primary no-underline visited:text-white"
		rel="noopener noreferrer"
		target="_blank"
	>
		<svg-icon
			[src]="'assets/icons/icon-' + icon + '.svg'"
			class="block size-4 footer-text-brand"
		/>
		{{ social }}
	</a>
</ng-template>
